//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').directive('scrollToListener', ['$window', function($window) {
    return {
      scope: {
        dependency: '=',
      },
      restrict: 'E',
      link(scope, element) {
        let scrollToLocation;
        scope.$watch('dependency', () => {
          if (scope.dependency) {
            scrollToLocation = angular.element(element)[0].offsetTop;
            $window.scrollTo(0, scrollToLocation);
            scope.dependency = false;
          }
        });
      },
    };
  }]);
})();
